import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../../shared/http/http-data.service';

import { IGenericUser } from '../../../../../type_definitions/datatypes';
import { IRole } from '../contacts/bp-profiles-contacts-data.service';

@Injectable()
export class BPProfilesAccessSettingsDataService {

  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public getGenericContacts(profileId:number):Promise<IGenericUser[]> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/genericcontacts`,
      {},
      undefined,
      'Error loading generic contacts'
    );
  }

  public getCompanyRoles(profileId:number, companyId:number, vendorCompanyId?:number):Promise<IRole[]> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/companies/${companyId}/roles`,
      { vendorCompanyId },
      undefined,
      'Error loading roles'
    );
  }
}